import { AxiosResponse } from 'axios'
import { axiosClient } from '@App/api/api-client'
import Pathes from '@App/dicts/pathes'
import { DistributionDate } from '@Entities/system-settings/distribution-date'

export const getDistributionDate = (): Promise<AxiosResponse<DistributionDate>> =>
    axiosClient.get(Pathes.SystemSettings.distributionDate)
